import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CriticalStyles extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (!this.props.shouldRender) {
      return null;
    }

    return (
      <style
        className="critical-css"
        dangerouslySetInnerHTML={{ __html: `${this.props.css}` }}
      />
    );
  }
}

CriticalStyles.propTypes = {
  css: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env !== 'development',
    css: state.config.criticalCss || ''
  };
}

export default connect(mapStateToProps)(CriticalStyles);



// WEBPACK FOOTER //
// ./src/views/components/head/critical_css.js